// extracted by mini-css-extract-plugin
export default {"webMain":"App_webMain__muvhs"};